export default "__VITE_ASSET__f3eb15dd__"